


















import { IJobMatchProfile } from '@app/componentlib/common/types/JobMatchTypes'
import { LocationModule } from '@app/componentlib/src/store/modules/locationdata'
import Vue from 'vue'
import Component from 'vue-class-component'
import LocationComponentsContainer from '../../components/location-components/LocationComponentsContainer.vue'
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch'
import { IRegion } from '@app/componentlib/common/types/LocationTypes'
import { IWizardStep } from '@app/componentlib/common/types/WizardTypes'
import { ISettingsItem } from '@app/componentlib/common/types/JobSearchTypes'

@Component<WizardStepJobMatchLocation>({
  components: {
    LocationComponentsContainer
  },
  props: {
    wizardstep: Object,
    settings: Object
  }
})

export default class WizardStepJobMatchLocation extends Vue {
  /**
   * Props variables
   */
  locationToInit: IRegion = {
    postal: this.jobmatchProfile.geoSettings?.zipCode || '',
    radius: this.jobmatchProfile.geoSettings?.radiusKm || 0,
    type: '',
    city: this.jobmatchProfile.geoSettings?.city || '',
    mapViewText: '',
    lat: this.jobmatchProfile.geoSettings?.latitude || 0,
    lon: this.jobmatchProfile.geoSettings?.longitude || 0
  }
  countryToInit: string = this.jobmatchProfile.geoSettings?.country ?? ''
  windowWidth: number = window.innerWidth
  wizardstep: IWizardStep | undefined
  settings: ISettingsItem | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */
   async mounted() {
    //Start search as soon as resultpage is mounted
    this.startSearch(false)

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  }

  unmounted() {
    window.removeEventListener('resize', this.onResize)
  }

  /**
   * Getters
   */
   get jobmatchProfile (): IJobMatchProfile {
    return JobMatchModule.jobMatchProfile
  }

  /**
   * Methods
   */
   async startSearch(isFromLocation: boolean) {
    // Check if search is started from location, if yes its location needs to be saved to jobmatch profile.
    if (isFromLocation && LocationModule.locations.length > 0) {
      const { postal, city, radius, lat, lon } = LocationModule.locations[0]
      let tempProfile = this.jobmatchProfile

      tempProfile.geoSettings = {
        zipCode: postal,
        city: city,
        radiusKm: radius,
        latitude: lat,
        longitude: lon,
        country: LocationModule.selectedCountry.countryCode
      }

      await JobMatchModule.updateJobMatchProfile(tempProfile)
    }

    await JobMatchModule.startSearch(true)
    await JobMatchModule.getJobMatchCount()
  }

  async resetProfileGeo() {
    await JobMatchModule.emptyProfileLocationData()
    await this.startSearch(false)
  }

  onResize() {
    this.windowWidth = window.innerWidth
  }
}
